import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-care-planning-container',
  templateUrl: './care-planning-container.component.html',
})
export class CarePlanningContainerComponent {

  constructor() { }

}
